import { Path, PathIcon } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { KnowledgeAssetSubTypeEnum } from '@/types/schema';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const config: ContentConfigProps = {
  routes: {
    create: () => routes.KnowledgeAssetCreate(KnowledgeAssetSubTypeEnum.Solution),
    edit: (id, type) => routes.KnowledgeAssetEditor(id, type),
    manageDetails: (id, type) => routes.KnowledgeAssetDetails(id, type), // admin link
    details: (id, type) => routes.KnowledgeAssetLearnerDetails(id, type), // learner link
  },
  label: RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.KnowledgeAsset],
  icons: {
    Type: Path,
    Create: Path,
    Icon: PathIcon,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
